export const css = {
	root: 'h_oIssCg',
	slideIn: 'r_zjpeFh',
	slideOut: '_3mZ8pkiF',
	underlayVisible: '_3Fzd3Z_x',
	content: '_1iMhnv39',
	pane: 'NJgyO0lU',
	title: '_3G4gPZ7b',
	titleContent: '_3Lv0hbkK',
	close: '_3TyBQKYO',
	closeIcon: '_2PbX7wJW',
	left: '_10ta6RBN',
	right: 'w2ZWAJlG',
	top: '_1LtpKlrY',
	bottom: '_2B8Uf2hF',
	open: '_2pos8ON6',
	' _key': 'apic-theme/apic/base-widgets/sliding-pane'
};

export default css;
